<template>
  <ux-atoms-typo :as="getTypoAs(elements)" class="Cms-richtext-text">
    <template :key="`cms-richtext-text-${index}`" v-for="(element, index) of elements">
      <ux-atoms-link
        :class="['Cms-richtext-text___link', element.marks?.map((mark) => `Cms-richtext-text___link--${mark}`)]"
        :target="isExternalURL(context, element.uri!) ? '_blank' : '_self'"
        :text="element.textContent"
        :to="element.uri"
        v-if="element.type === RichTextTextType.hyperlink"
      >
      </ux-atoms-link>
      <ux-atoms-typo
        :class="[element.marks?.map((mark) => `Cms-richtext-text--${mark}`)]"
        as="span"
        v-else-if="element?.textContent && (elements?.length > 1 || element?.marks.length)"
      >
        {{ element.textContent }}
      </ux-atoms-typo>
      <template v-else-if="element?.textContent">
        {{ element.textContent }}
      </template>
    </template>
  </ux-atoms-typo>
</template>

<script setup lang="ts" inherit-attrs="false">
import { useSSRContext } from 'vue';

import { isExternalURL } from '~/helpers/url';

import { RichTextComponentType, RichTextTextType } from '../types';

interface CmsRichTextTextProps {
  elements: PersonalizedPageElement[];
  nodeType: RichTextComponentType;
}

let context: Record<string, unknown> | undefined;

if (process.server) {
  context = useSSRContext();
}

defineProps<CmsRichTextTextProps>();

const getTypoAs = (elements: PersonalizedPageElement[]): keyof HTMLElementTagNameMap => {
  const type = elements.length > 0 ? elements[0].type : RichTextTextType.Paragraph;
  switch (type) {
    case RichTextTextType.Heading_2:
      return 'h2';
    case RichTextTextType.Heading_3:
      return 'h3';
    case RichTextTextType.Heading_4:
      return 'h4';
    case RichTextTextType.Heading_5:
      return 'h5';
    case RichTextTextType.Paragraph:
    default:
      return 'p';
  }
};
</script>

<style lang="scss" scoped>
@use 'CmsRichTextText.scss';
</style>
